import classNames from 'classnames'
import { getBrowserLanguage } from '@toasttab/shared/src/utils/formUtils'

export const validateEmail = (email: string) => {
  return !/^[a-zA-Z0-9]([a-zA-Z0-9._%+-]*)[a-z0-9]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(
    email
  )
}

export const validatePhoneInput = (phone: string, region: string) => {
  const phoneNumbersOnly = phone.replace(/\D/g, '')
  switch (region.toLowerCase()) {
    case 'uk':
      return !(phoneNumbersOnly.length === 11)
    case 'ie':
      return !(phoneNumbersOnly.length >= 9 && phoneNumbersOnly.length <= 10)
    case 'ca':
    case 'us':
    default:
      return !/^(\d{3})(\d{3})(\d{4})$/.test(phoneNumbersOnly)
  }
}

export const formatPhoneNumber = (phone: string) => {
  const cleanedPhoneNumber = ('' + phone).replace(/\D/g, '')
  const phoneSegments = cleanedPhoneNumber.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (!phoneSegments) return phone
  return `(${phoneSegments[1]}) ${phoneSegments[2]}-${phoneSegments[3]}`
}

export const getFloatingLabelClass = (
  value: string,
  touched: boolean,
  error: string | undefined
) =>
  classNames(
    `absolute left-[1rem] top-[0.75rem] text-[#666] transition-all duration-200 pointer-events-none`,
    'peer-placeholder-shown:top-3 peer-placeholder-shown:left-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-[#888]',
    'peer-focus:top-[0.25rem] peer-focus:left-[0.825rem] peer-focus:text-[0.625rem] peer-focus:text-[#666]',
    'peer-not-placeholder-shown:top-[-0.75rem] peer-not-placeholder-shown:left-2 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:text-[#222]',
    {
      '!top-[0.25rem] !left-[0.825rem] !text-[0.625rem] !text-[#666]': !!value
    }
  )

export const fieldClass =
  'peer block w-full bg-white border rounded-[6px] px-3 pt-4 pb-2 text-base text-[#222] focus:outline-none focus:border-blue-75 focus:border-2 transition'
export const fieldClassError = '!border !border-1 !border-[#f98699]'
export const fieldClassSelect =
  'block w-full bg-white border rounded-[6px] px-3 py-3 text-base text-[#222] focus:outline-none focus:border-blue-75 focus:border-2 transition appearance-none pr-10'
export const errorClass =
  'absolute form-error text-error mt-0 block text-[0.875rem] !text-[#f98699]'

export const hiddenFields = [
  'GCLID__c',
  'Website_Source_Detail__c',
  'craftFieldsetSlug',
  'Last_Blog_Seen__c',
  'Web_initiative__c',
  'Web_origin__c',
  'Web_detail__c',
  '_mktoReferrer',
  'pageFormSubmissionURL',
  'eI',
  'browserLanguage',
  'referrerURL',
  'returnURL',
  'munchkinId',
  '_mkt_trk',
  'mkoProgramName',
  'formid',
  'craftInferredCountry',
  'qQVersion',
  'fC',
  'gae',
  'referringPageURLText',
  'craftJavascriptStatus',
  'shownCalendly',
  'recaptchaValid',
  'progressiveEligible',
  'appendVariantTestText',
  'craftFormLocation',
  'cR',
  'craftRestaurantToast'
]

export const initialFormState = {
  mkoFullName: '',
  email: '',
  phone: '',
  company: '',
  postalCode: '',
  toastType: '',
  GCLID__c: '',
  Website_Source_Detail__c: '',
  craftFieldsetSlug: '',
  Last_Blog_Seen__c: '',
  Web_initiative__c: '',
  Web_origin__c: '',
  Web_detail__c: '',
  _mktoReferrer: '',
  pageFormSubmissionURL: '',
  eI: '',
  browserLanguage: getBrowserLanguage(),
  referrerURL: '',
  returnURL: '',
  munchkinId: '',
  _mkt_trk: '',
  mkoProgramName: '',
  formid: '',
  craftInferredCountry: '',
  qQVersion: '',
  fC: '',
  gae: '',
  referringPageURLText: '',
  craftJavascriptStatus: '',
  shownCalendly: '',
  recaptchaValid: '',
  progressiveEligible: '',
  appendVariantTestText: '',
  craftFormLocation: '',
  cR: '',
  craftRestaurantToast: '',
  action: ''
}
